module.exports = __webpack_public_path__ + "img/microsoft_365.57eebed4.png";